import React, { useState, useEffect, useMemo } from "react";
import { Button, Modal, Row, Col, Spinner } from "react-bootstrap";
import { Calendar3 } from "react-bootstrap-icons";
import _ from "lodash";
import TextField from "@mui/material/TextField";
import { Controller, useForm } from "react-hook-form";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import ApiAmusementGroup from "../../../../../../core/api/api.amusementGroup";
import ApiAmusementService from "../../../../../../core/api/api.amusementService";
import ApiBasketTemp from "../../../../../../core/api/api.basketTemp";
import ModalSelectDate from "./ModalSelectDate";
import SwalMessage from "../../../../_Components/SwalMessage";
import Select from "react-select";
import moment from "moment-jalaali";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
//import ReserveForm from "./ReserveForm";

function AddServiceItems(props) {
  //new Date(m.jYear()+'/'+m.jMonth()+'/'+m.jDate()).toLocaleDateString("fa-IR", { weekday: "long" })
  let nameSelectedForEdit = _.isUndefined(props.basketItem) ? "" : props.basketItem.amusementServiceName;
  let idSelectedplaceForEdit = _.isUndefined(props.basketItem) ? "" : props.basketItem.amusementServiceId;
  const toEnDigit = (n) => n?.replace(/[٠-٩۰-۹]/g, (n) => 15 & n.charCodeAt(0));
  let dateConvert = _.isUndefined(props.basketItem) ? "" : toEnDigit(props.basketItem.checkInDate);
  let m = moment(dateConvert, "jYYYY/jM/jD").format("YYYY-M-D");

  const [useDate, setUseDate] = useState({
    date: _.isUndefined(props.basketItem) ? "" : props.basketItem.checkInDate,
    day: _.isUndefined(props.basketItem) ? "" : new Date(m).toLocaleDateString("fa-IR", { weekday: "long" }),
    key: new Date(),
  });
  const {
    handleSubmit,
    control,
    setValue,
    formState: { isSubmitting },
    watch,
    getValues,
  } = useForm({
    defaultValues: {
      selectedserviceId: {
        label: nameSelectedForEdit,
        value: idSelectedplaceForEdit,
      },
      //dateSelected : _.isUndefined(props.basketItem) ? "" :(useDate.date= props.basketItem.checkInDate)
    },
  });

  const [show, setShow] = useState(true);
  const [amusementService, setAmusementService] = useState({});
  const [selectedPlace, setSelectedPlace] = useState({ id: 0 });
  //date  define
  const [modalSelectDate, setModalSelectDate] = useState(false);
  const [listSelective, setListSelective] = useState([]);
  const disabledelement = useMemo(() => nameSelectedForEdit != "" ? "disabled" : "", []);
  const watchradioSelectItemPerson = watch("radioSelectItemPerson", "");
  const handleModalSelectDate = () => {
    setModalSelectDate(!modalSelectDate);
  };

  const callBackForModalSelectDate = () => {
    setModalSelectDate(false);
  };
  const callBackForModalSelectDate2 = (item) => {
    setUseDate({
      date: item.date,
      day: item.day,
      key: item.key,
    });
  };
  ///////////////////////////////////
  const handleClose = () => {
    setShow(!show);
    props.callBack();
  };
  const formclean = () => {
    if (nameSelectedForEdit != "") {
      setValue("radioSelectItemPerson", "");
      setValue("counttiket", 0);
    } else {
      setValue("radioSelectItemPerson", "");
      setValue("counttiket", 0);
    }
  };

  useEffect(() => {
    (async () => {
      const amusementGroups = await ApiAmusementGroup.getAllGroups();
      const apiData = await ApiAmusementService.getAllServices();
      if (!_.isEmpty(apiData)) {
        setListSelective(apiData);
        nameSelectedForEdit != "" &&
          handleGetDataFormRezerv({ label: nameSelectedForEdit, value: idSelectedplaceForEdit }, "Edit", apiData);
      } else {
        SwalMessage({ title: apiData.message, iSsuccess: false });
        setListSelective([]);
        setValue("selectedserviceId", undefined);
      }
    })();
    return () => { };
  }, []);

  const onSubmit = (data) => {
    (async () => {
      try {
        const objData = {
          basketID: props.basketId,
          countTiket: getValues("counttiket"),
          reservDetail: "",
          personName:
            watchradioSelectItemPerson == "فرد جدید"
              ? getValues("fullnamePerson")
              : handleReturnRadioPersonId(watchradioSelectItemPerson),
          dateSelected: useDate.date, //JSON.stringify( useDate),
          amusementServiceId: amusementService.id,
          amusementPlaceId: selectedPlace,
        };
        if (objData.countTiket < 1 || _.isUndefined(objData.countTiket)) {
          SwalMessage({
            title: "تعداد نمی تواند کمتر از 1 باشد",
            iSsuccess: false,
          });
          return;
        } else if (_.isUndefined(objData.personName)) {
          SwalMessage({
            title: "لطفافرد مدنظر را صدور بلیط انتخاب نمایید",
            iSsuccess: false,
          });
          return;
        } else if (objData.dateSelected == "") {
          SwalMessage({
            title: "لطفاتاریخ استفاده از تفریح انتخاب نمایید",
            iSsuccess: false,
          });
          return;
        } else {
          var resp = await ApiBasketTemp.createItemBasket(objData);
          if (resp.succeeded) {
            SwalMessage({
              title: "تغییرات سبد با موفیت انجام شد.",
              iSsuccess: true,
            });
            formclean();

            //handleClose();
          } else
            SwalMessage({
              title: resp.message,
              iSsuccess: false,
            });
        }
      } catch (error) {
      }
    })();
  };
  const handlelistTypeChange = async (event, value) => {
    setValue("selectedGroupType", value.props.value);
    if (_.isNumber(value.props.value) && value.props.value > 0) {
      ApiAmusementService.getAll({
        pageSize: 200,
        pageNumber: 1,
        globalSearch: "{amusmentServiceID:" + value.props.value + " }",
      })
        .then((result) => {
        })
        .catch((error) => {
          console.error(error);
          return [];
        });
    }
  };

  const handleGetDataFormRezerv = async (event, value, data) => {
    let listSelective2 = value == "Edit" ? data : listSelective;
    var tt = listSelective2?.map((item) => {
      if (item.id == event.value && item.name == event.label) {
        setValue("selectedserviceId", event);
        var reserveDetailsTemp = _.attempt(JSON.parse.bind(null, item.reserveDetails));
        setValue("reserveFromDetail", _.isEmpty(item.reserveDetails) ? "فرم ناموجود" : item.reserveDetails);
        setAmusementService(item);
        if (!_.isEmpty(item.amusementServiceAmusementPlaces))
          setSelectedPlace(item.amusementServiceAmusementPlaces[0]?.amusementPlaceId);
      }
    });
  };
  // function placeSelected(placeId, placeName) {
  //   setSelectedPlace({ id: placeId, name: placeName });
  // }
  // function reservFormCallBack() {
  //   setSelectedPlace({
  //     id: 0,
  //     name: "",
  //     price: 0,
  //     originalPrice: 0,
  //     details: "",
  //   });
  // }
  function handleReturnRadioPersonId(event) {
    let tt = props?.basketItemPerson?.filter((item) => item.personFullName == event && item.id);
    return tt[0].id;
  }

  return (
    <Modal size="md" onHide={handleClose} show={show}>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Modal.Header closeButton>
          <Modal.Title>ثبت تفریح </Modal.Title>
          {/* <Button variant="none" onClick={handleClose}>
            <i className="fas fa-long-arrow-alt-left text-dark"></i>
          </Button> */}
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs="12">
              <Controller
                name="selectedserviceId"
                control={control}
                // rules={{ required: true, }}
                render={({ field: { onChange, value } }) => (
                  <Select
                    inputId="react-select-with-search"
                    className="w-100 mt-2"
                    variant="outlined"
                    size="small"
                    placeholder="سرویس"
                    options={listSelective?.map((item) => ({
                      value: item.id,
                      label: item.name,
                    }))}
                    isDisabled={disabledelement == "disabled" ? true : false}
                    value={value || ""}
                    onChange={handleGetDataFormRezerv}
                  />
                )}
              />
            </Col>

            <Col xs="12" className="mt-5">
              <Controller
                name="reserveFromDetail"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    type="text"
                    rows={3}
                    multiline
                    variant="outlined"
                    placeholder="توضیحات"
                    value={value}
                    onInput={onChange}
                    sx={{
                      ".css-1b76txz-MuiInputBase-root-MuiOutlinedInput-root": {
                        padding: "8.5px 14px 8.5px 0px !important",
                      }
                    }}
                    className="w-100"
                  />
                )}
              />
            </Col>
            <Col xs="12">
              <Controller
                name="dateSelected"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Button
                    size="sm"
                    variant="none"
                    className="d-flex    align-items-center py-1 px-0 bg-white mt-5"
                    onClick={handleModalSelectDate}
                    style={{ width: "100%", height: "35px", border: "1px solid #ccc" }}
                    value={value || ""}
                    disabled={disabledelement}
                  >
                    <div
                      className="d-flex justify-content-between align-items-center w-100 mx-0 py-0 px-3"
                      style={{ height: "35px" }}
                    >
                      <div>
                        <div className=" pr-2">
                          {!_.isEmpty(useDate.day) ? useDate.day + " - " + useDate.date : "تاریخ"}
                        </div>
                      </div>
                      <div>
                        <small className="  ml-1 text-muted ">
                          <Calendar3 size={20} />
                        </small>
                      </div>
                    </div>

                    {modalSelectDate && (
                      <ModalSelectDate
                        callBack={callBackForModalSelectDate}
                        callBack2={callBackForModalSelectDate2}
                        defaultDate={useDate.date}
                      />
                    )}
                  </Button>
                )}
              />
            </Col>

            <Col xs="12" className="mt-5">
              <div className="mb-2">انتخاب لیست افراد</div>
              <div
                className="bg-light px-3  rounded"
                style={{ height: "160px", overflowY: "scroll", overflowX: "hidden", border: "1px solid #ccc" }}
              >
                <Controller
                  name="radioSelectItemPerson"
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <RadioGroup
                      aria-label="Gender"
                      name="gender1"
                      className={"w-100 mt-1"}
                      value={value || ""}
                      onChange={onChange}
                    >
                      {props.basketItemPerson?.map((item, index) => (
                        <FormControlLabel value={item.personFullName} control={<Radio />} label={item.personFullName} />
                      ))}
                      <FormControlLabel value={"فرد جدید"} control={<Radio />} label={"فرد جدید"} />
                    </RadioGroup>
                  )}
                />
              </div>
              {watchradioSelectItemPerson == "فرد جدید" && (
                <Controller
                  name="fullnamePerson"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      type="text"
                      className="mt-5 w-100"
                      placeholder="نام و نام خانوادگی را وارد نمایید"
                      value={value}
                      onInput={onChange}
                    />
                  )}
                />
              )}
            </Col>

            <Col xs="12" className="mt-3">
              <Controller
                name="counttiket"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    type="number"
                    placeholder="تعداد بلیط"
                    value={value}
                    onInput={onChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="normal"
                  />
                )}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" type="submit" disabled={isSubmitting}>
            {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
            <SaveIcon className="mr-1" />
            ذخیره
          </Button>

          <Button variant="danger" onClick={handleClose}>
            <CloseIcon className="mr-1" />
            بستن
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default AddServiceItems;
